import React from 'react';
import PropTypes from 'prop-types';

import {Box, Button, Stack, TextField} from 'views/components';
import {SendOutlined, StopRounded} from 'views/icons';

const ChatInput = ({inputRef, value, onChange, onSend, loading, stoppable, canStop, onStop}) => {
  // While a turn runs, Send becomes Stop for agents that can be stopped.
  const showStop = loading && stoppable;

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      onSend();
    }
  };

  return (
    <Box sx={{px: '40px', py: '20px', borderTop: '1px solid #E8E4DE', flexShrink: 0}}>
      <Stack direction='row' alignItems='flex-end' sx={{gap: '10px', maxWidth: '720px', mx: 'auto'}}>
        <Box
          sx={{
            'flex': 1,
            'borderRadius': '10px',
            'border': '1px solid #E8E4DE',
            'backgroundColor': '#FBFBFB',
            'overflow': 'hidden',
            '&:focus-within': {borderColor: '#DA7955'},
          }}
        >
          <TextField
            inputRef={inputRef}
            value={value}
            onChange={onChange}
            onKeyDown={handleKeyDown}
            multiline
            maxRows={6}
            placeholder='Message the agent...'
            fullWidth
            variant='standard'
            disabled={loading}
            sx={{
              '& .MuiInputBase-root': {backgroundColor: 'transparent', px: '14px', py: '12px'},
              '& .MuiInputBase-input': {fontSize: '14px', color: '#1A1916', lineHeight: '160%'},
              '& .MuiInputBase-input::placeholder': {color: '#A8A49E', opacity: 1},
              '& .MuiInput-underline:before': {borderBottom: '0'},
              '& .MuiInput-underline:after': {borderBottom: '0'},
              '& .MuiInput-underline:hover:not(.Mui-disabled):before': {borderBottom: '0'},
            }}
          />
        </Box>
        <Button
          onClick={showStop ? onStop : onSend}
          disabled={loading ? !showStop || !canStop : !value.trim()}
          aria-label={showStop ? 'Stop' : 'Send'}
          disableElevation
          sx={{
            'minWidth': '0',
            'width': '40px',
            'height': '40px',
            'borderRadius': '10px',
            'p': 0,
            'backgroundColor': '#DA7955',
            'color': '#FFFFFF',
            '&:hover': {backgroundColor: '#DA7955', boxShadow: 'none'},
            '&.Mui-disabled': {backgroundColor: '#E8E4DE', color: '#A8A49E'},
          }}
        >
          {showStop ? <StopRounded sx={{fontSize: 19}} /> : <SendOutlined sx={{fontSize: 17}} />}
        </Button>
      </Stack>
    </Box>
  );
};

ChatInput.propTypes = {
  inputRef: PropTypes.object.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onSend: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  stoppable: PropTypes.bool.isRequired,
  canStop: PropTypes.bool.isRequired,
  onStop: PropTypes.func.isRequired,
};

export default ChatInput;
